import { addressRegex, emailRegex, emojiRegex, validatePostcode } from "./regex"

type TValue = string | null | undefined;

export const validateRequired = (value: TValue) => !value || (value && !value.trim()) ? "This field is required" : true;

export const validateEmoji = (value: TValue) => emojiRegex(value) ? "Emoji cannot be used" : true

export const validateCity = (value: TValue) => !addressRegex(value) ? "Please provide a valid city" : true

export const validateAddress = (value: TValue) => !value.trim() ? "Please provide a valid address" : true

export const validateEmail = (value: TValue) => !value.match(emailRegex) ? "Please provide a valid email address" : true

export const validateZipCode = (value: TValue) => value && !validatePostcode(value.trim()) ? "Please provide a valid ZIP code" : true